export default "__VITE_ASSET__DGEBiCRa__"